// app/[locale]/faq/FAQClient.tsx
"use client";
import FAQ from "@/app/components/faq/FAQ";

export default function FAQClient() {
  return <FAQ />;
}
